import styled from 'styled-components';

import { colors } from 'shared/defaultTheme';

const MultipleSelectSearchWrapper = styled.div`
  border: 1px solid ${colors.gullGrey};
  border-radius: 4px;
  min-height: 38px;
  padding-top: ${({ top }) => top}px;
  background-color: ${({ isDisabled }) => (isDisabled ? colors.colorReadonly : colors.white)};
  &.focus {
    /* border-bottom: 0; */
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
  &.error {
    background-color: ${colors.tutu};
    border: 1px solid ${colors.error};
  }
  .e-multiselect {
    border: none !important;
    overflow-y: auto;
    max-height: 180px;
    &:before {
      background-color: ${colors.transparent} !important;
    }
    &:after {
      background-color: ${colors.transparent} !important;
    }
    .e-chips {
      background-color: ${colors.transparent};
      border: 1px solid ${colors.black};
      margin-left: 5px;
      border-radius: 8px;
      &.e-chip-selected {
        background-color: ${colors.transparent};
      }
    }
    .e-chips-close {
      font-size: 9px;
      height: 13px;
      background: ${colors.transparent};
      &::before {
        font-size: 13px;
        color: ${colors.white};
        background-color: ${colors.transparent};
      }
    }
  }
  .e-multi-select-wrapper .e-chips {
    margin: 6px 0px 0px 5px;
  }
  .e-multi-select-wrapper {
    .e-chips-collection {
      display: block !important;
      .e-chipcontent {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        width: auto;
        max-width: 160px;
      }
    }
    .e-delim-values {
      display: none !important;
    }
  }
  .caret {
    fill: ${colors.black};
    height: 11px;
    width: 16px;
    position: absolute;
    top: 14px;
    right: 11px;
    background-image: url('${({ caret }) => caret}');
    background-position: center;
    background-size: cover;
  }
  .e-close-hooker {
    display: none;
  }
`;

export { MultipleSelectSearchWrapper };
